// @ts-check
/** @type {import('./types').Palette} */

const palette = {
  Blue600: '#116CDA',
  green200: '#E8F5F2',
  dark222: '#222',
  darkGrey: '#292a2c',
  lightGrey: '#4BA687',
  lightGrey_02: '#00875a',
  darkGrey80: 'rgb(41,42,44, 0.8)',
  brownishGrey: '#636363',
  lightBlueGrey: '#cfd4de',
  coral: '#fa5851',
  LightCoral: 'rgba(250, 88, 81, 0.6)',
  veryLightCoral: 'rgba(250, 88, 81, 0.1)',
  clearBlue: '#1b75e2',
  blue: '#2c83ed;',
  lightClearBlue: '#e8f1fc',
  bluishPurple: '#8036e5',
  poisonGreen: '#3cf11a',
  fadedOrange: '#fe9739',
  veryLightFadedOrange: 'rgba(254, 151, 57, 0.1)',
  violet: '#901be2',
  white: '#ffffff',
  whiteSmoke: '#f5f5f5',
  tomato: '#e2231b',
  darkGray: '#525252',
  gray87: '#dedede',
  lynxWhite: '#f7f7f7',
  lightSuccess: '#e0f7dc',
  darkSuccess: '#2fbd14',
  darkGreen: '#04a985',
  darkTurquoise: '#3496B5',
  purple: '#682a7a',
  pinkSwan: '#b6b5b5',
  black: '#000000',
  veryLightBlack: 'rgba(58,58,58, 0.1)',
  grey: '#757575',
  lightGray: '#f3f3f3',
  inputBorderColor: '#d1cece',
  inputBorderColorActive: '#7d7d7d',
  matterHorn: '#4b4b4b',
  gray34: '#575757',
  nero: '#282828',
  eclipse: '#3a3a3a',
  lightEclipse: 'rgba(58, 58, 58, 0.2)',
  black11: '#0A0A0A',
  darkPurple: '#7b1fa1',
  veryLightDarkPurple: 'rgba(123, 31, 161, 0.1)',
  veryLightGreenOpacity: 'rgba(4, 169, 133, 0.1)',
  lightGreyButtonBackground: 'rgba(207, 212, 222, .2)',
  validGreen: '#00c269',
  gray: '#eeeeee',
  green: '#5cc85c',
  lightYellow: '#faf8f0',
  athensGray: '#f9fafb',
  lightsSilver: '#d8d8d8',
  hesInfoBoxBackground: '#fef4eb',
  greenSuccess: '#5acc45',
  graniteGray: '#5f6061',
  coral_01: '#fdeeec',
  lightGreenBorder: ' #eef2f6',
  iron: '#CFD4DE',
  red: '#E2231B',
  yellow: '#FFB800',
  persianRed: '#D1392B',
  dawnPink: '#f6e5e5',
  aquaSqueeze: '#e5f6f2',
  lightRed: '#FEEEED',
  burntSienna: '#E96358',
  transparent: 'rgba(0, 0, 0, 0.4)',
  scooter: '#2CB7CE',
  orange: '#FE9739',
  purple500: '#f2eafc',
  blueDark: 'rgba(27, 117, 226, 0.1)',
  teal600: '#4BABC9',
  teal200: '#EEF7FA',
  iceberg: '#E8F5F2',
  darkGreenScore: '#4CA671',
  darkRed: '#d30012',
  lighterGray: '#f0f0f0',
  lightGray2: '#d9d9d9',
  brownishGray: '#fafafa',
  transparent2: 'transparent',
  grayWhite: 'rgb(247, 247, 247)',
  darkBlue: '#00285F',
  shineRed: '#DA0223',
  // Brand Colors
  BR500: '#E2231B',
  BR400: '#F1332B',
  BR300: '#FA5851',
  BR200: '#F37672',
  BR100: '#FA8B87',
  BR75: '#FFB8B6',
  BR50: '#FFE4E3',
  // Red Colors
  R600: '#D1392B',
  R500: '#BF2600',
  R400: '#DE350B',
  R300: '#FF5630',
  R200: '#FF7452',
  R100: '#FF8F73',
  R75: '#FFBDAD',
  R50: '#FFEBE6',
  // Orange Colors
  O500: '#FF8B00',
  O400: '#FF991F',
  O300: '#FFAB00',
  O200: '#FFC400',
  O100: '#FFE380',
  O75: '#FFF0B3',
  O50: '#FFFAE6',
  // Green Colors
  G500: '#006644',
  G400: '#00875A',
  G300: '#36B37E',
  G200: '#57D9A3',
  G100: '#79F2C0',
  G75: '#ABF5D1',
  G50: '#E3FCEF',
  // Teal Colors
  T500: '#008DA6',
  T400: '#00A3BF',
  T300: '#00B8D9',
  T200: '#00C7E6',
  T100: '#79E2F2',
  T75: '#B3F5FF',
  T50: '#E6FCFF',
  // Blue Colors
  B500: '#0747A6',
  B400: '#0052CC',
  B300: '#0047FF',
  B200: '#2684FF',
  B100: '#4C9AFF',
  B75: '#B3D4FF',
  B50: '#DEEBFF',
  // Purple Colors
  P500: '#403294',
  P400: '#5243AA',
  P300: '#6554C0',
  P200: '#8777D9',
  P100: '#998DD9',
  P75: '#C0B6F2',
  P50: '#EAE6FF',
  // Dark Colors
  D500: '#000000',
  D400: '#292A2C',
  D300: '#3A3A3A',
  D200: '#525252',
  D100: '#636363',
  D75: '#757575',
  D50: '#939393',
  D40: '#B0B0B0',
  D30: '#D6D6D6',
  D20: '#ECECEC',
  D10: '#F8F8F8',
  D5: '#FAFAFA',
  // Neutral light Colors
  NL900: '#091E42',
  NL800: '#172B4D',
  NL700: '#253858',
  NL600: '#344563',
  NL500: '#42526E',
  NL400: '#505F79',
  NL300: '#5E6C84',
  NL200: '#6B778C',
  NL100: '#7A869A',
  NL90: '#8993A4',
  NL80: '#97A0AF',
  NL70: '#A5ADBA',
  NL60: '#B3BAC5',
  NL50: '#C1C7D0',
  NL40: '#DFE1E6',
  NL30: '#EBECF0',
  NL20: '#F4F5F7',
  NL10: '#FAFBFC',
  NL0: '#FFFFFF',
};

module.exports = palette;
